<template>
    <default-template class="app--main">
        <!-- Main.vue 페이지 내용 -->
        <slot />
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate
    }
}
</script>